import { IContact } from '@cemex-core/cmx-api/models/contact/contact';

import {
  LOAD,
  LOAD_COMPLETE,
  ReceivingPersonsActions,
  REMOVE_SELECTED_PERSON,
  SET,
  LOAD_INITIAL_STATE,
  TOGGLE_AVAILABLE,
  TOGGLE_CREATE_FORM_VISIBLE,
  ADD_LOCAL_CONTACT,
  SET_MULTIPLE,
  ADD_MULTIPLE,
  CONTACT_DELETE_BY_ID,
  LOAD_DEFAULT_EMAIL_COMPLETE,
  DELETE_CONTACT_FAILURE,
  DELETE_CONTACT,
  DELETE_CONTACT_SUCCESS,
  DELETE_CONTACT_RESET_STATUS,
} from '@ordersnproducts/modules/shared/modules/receiving-person/redux/actions/receiving-person.actions';
import { ILocationConfigUnit } from '@ordersnproducts/modules/order-builder/modules/location/models/location-config.interface';
import { OrderBuilderActions, RESET_BUILDER } from '@ordersnproducts/modules/order-builder/actions/order-builder.actions';

export interface IReceivingPersonsState {
  required: boolean;
  disabled: boolean;
  visible: boolean;
  loaded: boolean;
  loading: boolean;
  receivingPersons: IContact[];
  selected: IContact;
  multipleOrdersSelected: IContact [];
  createFormVisible: boolean;
  createFormCancelable: boolean;
  strictPhoneNumber?: boolean;
  defaultEmail?: string;
  contactDeleteStatus?: undefined | 200 | 404;
}

export const initialState: IReceivingPersonsState = {
  required: false,
  disabled: false,
  visible: false,
  loaded: false,
  loading: false,
  receivingPersons: [],
  multipleOrdersSelected: [],
  selected: null,
  createFormVisible: false,
  createFormCancelable: false,
};

export function receivingPersonsReducer(
  state = initialState,
  action: ReceivingPersonsActions | OrderBuilderActions  ,
): IReceivingPersonsState {
  // @ts-ignore
  switch (action.type) {
    case LOAD_INITIAL_STATE: {
      if (action.payload) {
        const receivingPersonConfig: ILocationConfigUnit = action.payload;
        return {
          ...state,
          disabled: receivingPersonConfig.disabled && !(state.receivingPersons.length > 0),
          required: receivingPersonConfig.required,
          visible: receivingPersonConfig.visible,
          strictPhoneNumber: receivingPersonConfig.strictPhoneNumber,
        };
      } else {
        return {
          ...initialState,
        };
      }
    }
    case LOAD: {
      return {
        ...state,
        loading: true,
      };
    }
    case LOAD_COMPLETE: {
      const receivingPersons: IContact[] = action.payload;
      const hasRecipients = receivingPersons.length > 0;

      return {
        ...state,
        loaded: true,
        loading: false,
        disabled: false,
        receivingPersons,
        createFormVisible: !hasRecipients,
        createFormCancelable: hasRecipients,
      };
    }

    case TOGGLE_AVAILABLE: {
      return {
        ...state,
        disabled: action.payload,
      };
    }
    case SET: {
      let receivingPersons = state.receivingPersons;
      if (action.refreshPersons) {
        receivingPersons = [action.payload, ...state.receivingPersons];
      }
      return {
        ...state,
        receivingPersons,
        selected: action.payload,
      };
    }
    case ADD_MULTIPLE: {
      let receivingPersons = state.multipleOrdersSelected;
      const alreadyInList = state.multipleOrdersSelected.find(contact =>
        contact.contactId === action.payload.contactId);
      if (action.refreshPersons && !alreadyInList) {
        receivingPersons = [action.payload, ...state.multipleOrdersSelected];
      }
      return {
        ...state,
        multipleOrdersSelected: receivingPersons,
      };
    }
    case SET_MULTIPLE: {
      let receivingPersons = action.payload;
      if (action.refreshPersons) {
        receivingPersons = [...state.multipleOrdersSelected, ...action.payload];
      }
      return {
        ...state,
        multipleOrdersSelected: receivingPersons,
      };
    }
    case TOGGLE_CREATE_FORM_VISIBLE: {
      return {
        ...state,
        createFormVisible: action.payload,
      };
    }
    case RESET_BUILDER:
    case REMOVE_SELECTED_PERSON: {
      return {
        ...state,
        loaded: false,
        loading: false,
        selected: null,
        multipleOrdersSelected: [],
        receivingPersons: [],
      };
    }
    case ADD_LOCAL_CONTACT: {
      const newArray = state.receivingPersons.concat(action.payload);
      return {
        ...state,
        loaded: true,
        loading: false,
        disabled: false,
        receivingPersons: newArray,
      };
    }
    case CONTACT_DELETE_BY_ID: {
      return {
        ...state,
        receivingPersons: state.receivingPersons.filter(contact => contact.contactId !== action.payload),
      };
    }
    case LOAD_DEFAULT_EMAIL_COMPLETE: {
      return {
        ...state,
        defaultEmail: action.payload,
      };
    }
    case LOAD_DEFAULT_EMAIL_COMPLETE: {
      return {
        ...state,
        defaultEmail: action.payload,
      };
    }
    case DELETE_CONTACT: {
      return {
        ...state,
      };
    }
    case DELETE_CONTACT_SUCCESS: {
      return {
        ...state,
        contactDeleteStatus: 200,
      };
    }
    case DELETE_CONTACT_FAILURE: {
      return {
        ...state,
        contactDeleteStatus: 404,
      };
    }
    case DELETE_CONTACT_RESET_STATUS: {
      return {
        ...state,
        contactDeleteStatus: undefined,
      };
    }
    default: {
      return state;
    }
  }
}
